import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UiService } from 'src/app/services/ui.service';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-room-selection-modal',
  templateUrl: './room-selection-modal.component.html',
  styleUrls: ['./room-selection-modal.component.scss'],
})
export class RoomSelectionModalComponent implements OnInit {
  @Input() guestRoomsInfo: any[];
  @Input() maxGuestPerRoom: { adults: number; children: number };
  public currentHeaderData: any = {
    modalSlotEnd: true,
    marl20: true,
    title: 'hotel.room_seletion_modal.header',
  };
  public canFireToast = true;

  constructor(
    private modalController: ModalController,
    private uiService: UiService,
    private translate: TranslateService,
    private analyticsService: AnalyticsService
  ) {}
  ngOnInit() {}

  addRoom() {
    if (this.guestRoomsInfo.length < 6) {
      this.guestRoomsInfo.push({
        adults: 1,
        children: 0,
        childrenAges: [],
      });
    } else {
      if (this.canFireToast) {
        this.canFireToast = false;
        this.uiService.presentToast(
          this.translate.instant(
            'toast_message.maximum_6_Rooms_allowed_in_single_booking'
          )
        );
        setTimeout(() => {
          this.canFireToast = true;
        }, 2500);
      }
    }
  }

  removeRoom() {
    this.guestRoomsInfo.pop();
  }

  submitChanges() {
    this.modalController.dismiss({ guestRoomsInfo: this.guestRoomsInfo });
  }

  closeModal() {
    this.analyticsService.trackUnified('guest_room_selection_closed', {
      flow: 'hotel',
      outcome: 'abandon',
      legacy_event_name: 'Guest-Room Selection Close',
      button: 'room-selection-close',
    });
    this.modalController.dismiss();
  }

  removeAdult(index) {
    const currentRoom = this.guestRoomsInfo[index];
    if (currentRoom.adults > 1) {
      currentRoom.adults--;
    }
  }

  addAdult(index) {
    const currentRoom = this.guestRoomsInfo[index];

    // If maxGuestPerRoom is provided, use dynamic restrictions
    if (this.maxGuestPerRoom) {
      const maxAdults = this.maxGuestPerRoom.adults;
      const maxChildren = this.maxGuestPerRoom.children;
      const totalGuests = currentRoom.adults + currentRoom.children;
      const maxTotalGuests = maxAdults + maxChildren;

      // Check if we can add an adult: must not exceed individual adult limit AND total limit
      if (currentRoom.adults < maxAdults && totalGuests < maxTotalGuests) {
        currentRoom.adults++;
      } else {
        if (this.canFireToast) {
          this.canFireToast = false;
          let message = '';
          if (currentRoom.adults >= maxAdults) {
            message = `Maximum ${maxAdults} adults allowed in single room`;
          } else {
            message = `Maximum ${maxTotalGuests} guests allowed in single room`;
          }
          this.uiService.presentToast(message);
          setTimeout(() => {
            this.canFireToast = true;
          }, 2500);
        }
      }
    } else {
      if (currentRoom.adults < 6) {
        currentRoom.adults++;
      } else {
        if (this.canFireToast) {
          this.canFireToast = false;
          this.uiService.presentToast(
            this.translate.instant(
              'toast_message.maximum_6_Adults_allowed_in_single_room'
            )
          );
          setTimeout(() => {
            this.canFireToast = true;
          }, 2500);
        }
      }
    }
  }

  addChild(index) {
    const currentRoom = this.guestRoomsInfo[index];
    if (this.maxGuestPerRoom) {
      const maxAdults = this.maxGuestPerRoom.adults;
      const maxChildren = this.maxGuestPerRoom.children;
      const totalGuests = currentRoom.adults + currentRoom.children;
      const maxTotalGuests = maxAdults + maxChildren;
      if (totalGuests < maxTotalGuests) {
        currentRoom.children++;
        currentRoom.childrenAges.push(1);
      } else {
        if (this.canFireToast) {
          this.canFireToast = false;
          const message = `Maximum ${maxTotalGuests} guests allowed in single room`;
          this.uiService.presentToast(message);
          setTimeout(() => {
            this.canFireToast = true;
          }, 2500);
        }
      }
    } else {
      if (currentRoom.children < 4) {
        currentRoom.children++;
        currentRoom.childrenAges.push(1);
      } else {
        if (this.canFireToast) {
          this.canFireToast = false;
          this.uiService.presentToast(
            this.translate.instant(
              'toast_message.maximum_4_Children_allowed_in_single_room'
            )
          );
          setTimeout(() => {
            this.canFireToast = true;
          }, 2500);
        }
      }
    }
  }

  removeChild(index) {
    if (this.guestRoomsInfo[index].children > 0) {
      this.guestRoomsInfo[index].children--;
      this.guestRoomsInfo[index].childrenAges.pop();
    }
  }

  addChildAge(event, index, childIndex) {
    this.guestRoomsInfo[index].childrenAges[childIndex] = event.target.value;
  }
}
